import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { systemDecimalFormat } from '~Betslip/utils/numberFormatters';

const KeyboardContext = React.createContext();

const useKeyboard = () => {
    const context = useContext(KeyboardContext);

    return context;
};

const KeyboardProvider = ({children}) => {
    const [ keyboardContainerRef, setKeyboardContainerRef ] = useState(null);
    const [ stakeFieldRef, setStakeFieldRef ] = useState(null);
    const [ freebets, setFreebets ] = useState([]);
    const [ selectedFreebet, setSelectedFreebet ] = useState(null);

    const triggerInputOnChange = (newValue, withFocus = true, freebet = null) => {
        if (!stakeFieldRef.current) {
            return;
        }

        const input = stakeFieldRef.current;
        input.freebetId = freebet?.id || null;
        const currentValue = input.value;
        input.value = newValue;
        input._valueTracker.setValue(currentValue);
        input.dispatchEvent(
            new Event('input', { bubbles: true })
        );

        if (withFocus) {
            input.focus();
        }
    };

    const addChar = (char) => {
        const currentValue = stakeFieldRef.current.value;
        const newValue = `${currentValue}${char}`;

        triggerInputOnChange(newValue);
    };

    const removeLastChar = () => {
        if (selectedFreebet) {
            setSelectedFreebet(null);
            triggerInputOnChange('');
        }
        triggerInputOnChange(
            stakeFieldRef.current.value.slice(0, -1)
        );
    };

    const incrementBy = (value) => {
        if (selectedFreebet) {
            setSelectedFreebet(null);
            triggerInputOnChange('');
        }
        const currentValue = stakeFieldRef.current.value;
        const incrementedValue = Number(currentValue) + Number(value);
        triggerInputOnChange(
            systemDecimalFormat(incrementedValue)
        );
    };

    const closeKeyboard = () => {
        setKeyboardContainerRef(null);
        setStakeFieldRef(null);
    };

    const selectFreebet = (freebet) => {
        triggerInputOnChange('', true, freebet);
        setSelectedFreebet(freebet);
    };

    const value = {
        // Keyboard Ref
        keyboardContainerRef,
        setKeyboardContainerRef,

        // Stake Field Ref
        stakeFieldRef,
        setStakeFieldRef,

        // API
        closeKeyboard,
        addChar,
        removeLastChar,
        incrementBy,

        // Freebets
        freebets,
        setFreebets,
        selectedFreebet,
        selectFreebet,
        setSelectedFreebet,
    };

    return <KeyboardContext.Provider value={value}>
        {children}
    </KeyboardContext.Provider>;
};

KeyboardProvider.propTypes = {
    children: PropTypes.element.isRequired,
};

export {
    KeyboardProvider,
    useKeyboard,
};
